import { render, staticRenderFns } from "./UserInteractionsStats.vue?vue&type=template&id=c939667a&scoped=true&"
import script from "./UserInteractionsStats.vue?vue&type=script&lang=js&"
export * from "./UserInteractionsStats.vue?vue&type=script&lang=js&"
import style0 from "./UserInteractionsStats.vue?vue&type=style&index=0&id=c939667a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c939667a",
  null
  
)

export default component.exports